import { createFileRoute } from '@tanstack/react-router';

import { getCompanyQueryOptions } from '@/_pages/companies/api-service';
import Loading from '@/_pages/companies/contacts/loading';

export const Route = createFileRoute('/_private/companies/_template/$id/contacts')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getCompanyQueryOptions(opts.params.id)),
  staticData: {
    pageTitle: 'Contacts',
    tabKey: 'client/contacts',
  },
  pendingComponent: Loading,
});
